import { render, staticRenderFns } from "./orderhis.vue?vue&type=template&id=492d5c8f&scoped=true"
import script from "./orderhis.vue?vue&type=script&lang=js"
export * from "./orderhis.vue?vue&type=script&lang=js"
import style0 from "./orderhis.vue?vue&type=style&index=0&id=492d5c8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d5c8f",
  null
  
)

export default component.exports